<script setup>
import Button from './Button.vue';
import CustomLink from './CustomLink.vue';
import autoAnimate from "@formkit/auto-animate"
import { ref, onMounted } from 'vue'

const faqs = [
    {
        question: 'Is financiering mogelijk bij jullie?',
        answer: 'Ja, wij bieden verschillende financieringsmogelijkheden. Samen kijken we naar een oplossing die bij jouw budget en wensen past. Neem contact met ons op voor een vrijblijvend advies of vul het formulier online in bij de betreffende auto. Zo simpel kan het zijn.'
    },
    {
        question: 'Hoe zit het met de onderhoudshistorie?',
        answer: 'Wij kopen alleen auto\'s met een volledige onderhoudshistorie en voeren een grondige controle uit voordat ze verkocht worden. Zo ben jij verzekerd van een betrouwbare auto. Je kunt de historie altijd bij de dealer of via de documentatie controleren!'
    },
    {
        question: 'Kan ik een proefrit maken?',
        answer: 'Natuurlijk! We raden altijd aan om een proefrit te maken. Neem even contact op om een afspraak te plannen, zodat we de auto voor je klaar kunnen zetten.'
    },
    {
        question: 'Komen er extra kosten bij de prijs?',
        answer: 'Nee, geen verrassingen. Wij hanteren transparante prijzen zonder verborgen kosten. De prijs die je ziet, is de prijs die je betaalt.'
    },
    {
        question: 'Kan ik mijn auto inruilen?',
        answer: 'Ja, je kunt je auto bij ons inruilen. We bieden een eerlijke en marktconforme prijs. Stuur ons wat foto\'s en details, of kom langs voor een taxatie. We doen je graag een goed bod.'
    },
    {
        question: 'Hoe werkt de garantie precies?',
        answer: 'Ja, we bieden verschillende garantie-opties aan voor extra zekerheid. Vraag ons naar de mogelijkheden. In de meeste gevallen zien wij dit als een sblackdaard.'
    },
    {
        question: 'Hoe kan ik jullie bereiken?',
        answer: 'Je kunt ons bellen, WhatsAppen of mailen. Liever langskomen? Je bent altijd welkom op onze locatie in Borne!'
    }
]

const dropdowns = ref([]) // we need a DOM node
const show = ref([])

//populate show array with the faq objects

faqs.forEach(() => {
    show.value.push(false)
})

function toggle(index) {
    show.value[index] = !show.value[index]
}

onMounted(() => {
    dropdowns.value.forEach((dropdown, index) => {
        autoAnimate(dropdown)
    })
})
</script>
<template>

    <section class="flex flex-col bg-black text-white -space-y-56 w-full overflow-hidden">
        <!--hero-->
        <div>
            <div class="h-full text-white">
            <div class="h-screen flex flex-col max-h-[1200px]">
                <!-- <video :src="'/videos/faqvid.webm'" autoplay loop muted playsinline class="absolute w-full h-full max-h-[1200px] aspect-video object-cover" /> -->
                <img :src="'/img/showroom/zwagers_automotive_show_25.webp'" alt="faq" class="absolute w-full h-full max-h-[1200px] aspect-video object-cover object-bottom" />
                <div class="flex justify-center h-screen w-screen min-h-96 bg-black/70 z-10">
                <div class="w-11/12 px:0 md:px-6 xl:px-0 max-w-6xl mx-auto h-4/6 sm:h-5/6">
                    <div class="flex flex-col gap-10 h-full justify-center">
                    <div class="space-y-5">
                        <h2 class="text-shadow">Vind jouw auto</h2>
                        <p class="texxt-shadow hidden sm:block lg:w-7/12 text-pretty">Toch niet helemaal wat je zoekt? Wij helpen je om jouw auto te vinden. Neem contact met ons op dan kijken we samen naar de mogelijkheden.</p>
                        <div class="flex flex-col sm:flex-row gap-4 w-full pt-6 md:pt-16">
                        <CustomLink href="/overons#contactform" type="href" class="primary-button">
                            Contact
                        </CustomLink>
                        <CustomLink href="#faq" type="href" class="secondary-white-button">
                            Meer info
                        </CustomLink>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>

        <div id="faq"
            class="flex justify-center py-8 md:py-20 lg:py-28 bg-gradient-to-b from-transparent to-15% to-black text-white z-10">
            <div class="w-11/12 px:0 md:px-6 xl:px-0 max-w-6xl mx-auto flex flex-col gap-10">
                <!-- <div class="flex flex-col gap-4 pb-6 md:pb-16 lg:pb-20">
                    <h2>Veelgestelde vragen</h2>
                    <p class="w-full text-balance">Lees hier de meest gestelde vragen. Nog steeds meer vragen dan antwoorden, neem dan contact op met ons.</p>
                </div>
                <section id="faq" class="divide-y border-b">
                    <div ref="dropdowns" v-for="(faq, index) in faqs" :key="faq.question" class="py-3">
                        <strong class="flex justify-between items-center cursor-pointer" @click="toggle(index)">
                            {{ faq.question }}
                            <font-awesome-icon :icon="['far', 'chevron-down']" class="h-4 w-4 transition-transform duration-300 ease-in-out" :class="show[index] ? '-rotate-180' : ''" aria-hidden="true" />
                        </strong>
                        <p v-if="show[index]" class="text-base/7 text-gray-300 pt-2">{{ faq.answer }}</p>
                    </div>
                </section> -->
                <div class="flex flex-col sm:text-center pt-0 sm:pt-8 lg:pt-20 gap-4 w-auto">
                    <h2 class="text-white">Heb je vragen?</h2>
                    <p class="text-white">Neem dan contact met ons op.</p>
                    <div class="flex flex-col w-full justify-center sm:flex-row gap-6">
                        <Button href="/overons#contactform" type="href" class="primary-button">
                            Contact
                        </Button>
                        <!--TO WHATSAPP TEL:-->
                        <CustomLink href="https://wa.me/+31617328160" type="href" target="_blank" class="secondary-white-button" :useInertia="false">
                            <font-awesome-icon :icon="['fab', 'whatsapp']" class="h-5 w-5" />
                            Whatsapp
                        </CustomLink>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>
